import { useEffect } from 'react';

import { GatewayRulesFormValues } from 'pages/GatewayRules/components/GatewayRulesForm/hooks/useGatewayRulesForm';
import { useFormContext } from 'react-hook-form';
import { Gateway } from 'types/embedded/gateway';

type Params = {
  mappingIndex: number;
  mappingItemIndex: number;
  gateways: Gateway[];
};

export function useAutoSelectGateway({ mappingIndex, mappingItemIndex, gateways }: Params) {
  const { watch, setValue } = useFormContext<GatewayRulesFormValues>();

  const merchantWatched = watch('merchant');
  const methodWatched = watch(`mappings.${mappingIndex}.method`);
  const directionWatched = watch(`mappings.${mappingIndex}.direction`);
  const gatewayWatched = watch(`mappings.${mappingIndex}.mappingItems.${mappingItemIndex}.gateway`);
  const mappingItemsWatched = watch(`mappings.${mappingIndex}.mappingItems`);

  // шлюзы, уже занятые в других элементах этого маппинга
  const usedGatewayIds = mappingItemsWatched
    .filter((_, id) => id !== mappingItemIndex)
    .map((item) => item.gateway)
    .filter(Boolean);

  const canAutoSelectGateway =
    Boolean(merchantWatched) &&
    Boolean(methodWatched) &&
    Boolean(directionWatched) &&
    !gatewayWatched;

  useEffect(() => {
    if (!canAutoSelectGateway || !gateways?.length) {
      return;
    }
    const availableGateways = gateways.filter((g) => !usedGatewayIds.includes(g.id));

    if (availableGateways.length === 1) {
      setValue(
        `mappings.${mappingIndex}.mappingItems.${mappingItemIndex}.gateway`,
        availableGateways[0].id,
        { shouldDirty: true, shouldValidate: true },
      );
    }
  }, [gateways, canAutoSelectGateway, usedGatewayIds.join(',')]);
}
